import script from "./message-composer.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-composer.vue?vue&type=script&lang=ts&setup=true"

import "./message-composer.vue?vue&type=style&index=0&id=0fd90104&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fd90104"]])

export default __exports__